module.exports = __webpack_public_path__ + "img/qr-slide-1.11f48a33.png";